module.exports = __webpack_public_path__ + "assets/ba7642a84c2f6619c276414e2a905946.png";